export default {
  methods: {
    localizedDate(date) {
      if (date) {
        return this.$d(new Date(date), 'short', 'ja')
      }
      return '—'
    }
  }
}
